import { createReducer } from '@reduxjs/toolkit';

import getWarehouseMpnInfo, { clearWarehouseMpnInfo } from '../../../thunks/coilovers/warehouse/getWarehouseMpnInfo';

const initialState = {
  loading: false,
  error: null,
  data: {},
};

const getWarehouseMpnInfoReducer = createReducer(initialState, {
  [getWarehouseMpnInfo.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getWarehouseMpnInfo.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: {
      ...state.data,
      [payload?.part_whs_mpn]: payload
    },
  }),
  [getWarehouseMpnInfo.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [clearWarehouseMpnInfo]: (state) => state,
});

export default getWarehouseMpnInfoReducer;
